import { SWRConfiguration } from 'swr';

import { UseArraySWROutput, useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';
import { AppModules } from '~/services/Permissions';

import { useModulesConfig } from '../company';

import { CustomDataFieldAttributes } from './types';

export const SWR_KEY_CUSTOM_DATA_ATTRIBUTES =
  'getCustomEmployeeFieldAttributes';

export const getCustomEmployeeFieldAttributes = (): Promise<
  CustomDataFieldAttributes[]
> => {
  return fetchFromOldApi(`/json/customdata/entity/EMPLOYEE/attribute`).then(
    (r) => r.json(),
  );
};

export const useCustomDataAttributes = (
  swrConfig?: SWRConfiguration,
  isDisabled?: boolean,
): UseArraySWROutput<CustomDataFieldAttributes> => {
  const { isModuleEnabled } = useModulesConfig();
  const isCustomDataEnabled = isModuleEnabled(AppModules.CUSTOM_DATA);

  return useArraySWR<CustomDataFieldAttributes>(
    !isDisabled && isCustomDataEnabled
      ? [SWR_KEY_CUSTOM_DATA_ATTRIBUTES]
      : null,
    () => getCustomEmployeeFieldAttributes(),
    swrConfig,
  );
};
